export const GET_TEMPLATE_INFO_START = "GET_TEMPLATE_INFO_START";
export const GET_TEMPLATE_INFO_SUCCESS = "GET_TEMPLATE_INFO_SUCCESS";
export const GET_TEMPLATE_INFO_FAIL = "GET_TEMPLATE_INFO_FAIL";

export const GET_TEMPLATES_START = "GET_TEMPLATES_START";
export const GET_TEMPLATES_SUCCESS = "GET_TEMPLATES_SUCCESS";
export const GET_TEMPLATES_FAIL = "GET_TEMPLATES_FAIL";

export const CREATE_TEMPLATE_START = "CREATE_TEMPLATE_START";
export const CREATE_TEMPLATE_SUCCESS = "CREATE_TEMPLATE_SUCCESS";
export const CREATE_TEMPLATE_FAIL = "CREATE_TEMPLATE_FAIL";

export const UPDATE_TEMPLATE_START = "UPDATE_TEMPLATE_START";
export const UPDATE_TEMPLATE_SUCCESS = "UPDATE_TEMPLATE_SUCCESS";
export const UPDATE_TEMPLATE_FAIL = "UPDATE_TEMPLATE_FAIL";

export const DELETE_TEMPLATE_START = "DELETE_TEMPLATE_START";
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_FAIL = "DELETE_TEMPLATE_FAIL";

export const ARCHIVE_TEMPLATE_START = "ARCHIVE_TEMPLATE_START";
export const ARCHIVE_TEMPLATE_SUCCESS = "ARCHIVE_TEMPLATE_SUCCESS";
export const ARCHIVE_TEMPLATE_FAIL = "ARCHIVE_TEMPLATE_FAIL";

export const GET_TIME_BOUNDS_START = "GET_TIME_BOUNDS_START";
export const GET_TIME_BOUNDS_SUCCESS = "GET_TIME_BOUNDS_SUCCESS";
export const GET_TIME_BOUNDS_FAIL = "GET_TIME_BOUNDS_FAIL";

export const GET_MAILING_TRIGGERS_START = "GET_MAILING_TRIGGERS_START";
export const GET_MAILING_TRIGGERS_SUCCESS = "GET_MAILING_TRIGGERS_SUCCESS";
export const GET_MAILING_TRIGGERS_FAIL = "GET_MAILING_TRIGGERS_FAIL";

export const ACTIVATE_TEMPLATE_START = "ACTIVATE_TEMPLATE_START";
export const ACTIVATE_TEMPLATE_SUCCESS = "ACTIVATE_TEMPLATE_SUCCESS";
export const ACTIVATE_TEMPLATE_FAIL = "ACTIVATE_TEMPLATE_FAIL";

export const GET_GROUPED_TEMPLATES_START = "GET_GROUPED_TEMPLATES_START";
export const GET_GROUPED_TEMPLATES_SUCCESS = "GET_GROUPED_TEMPLATES_SUCCESS";
export const GET_GROUPED_TEMPLATES_FAIL = "GET_GROUPED_TEMPLATES_FAIL";

export const GET_BONUS_CARD_MAILING_TEMPLATES_START = "GET_BONUS_CARD_MAILING_TEMPLATES_START";
export const GET_BONUS_CARD_MAILING_TEMPLATES_SUCCESS = "GET_BONUS_CARD_MAILING_TEMPLATES_SUCCESS";
export const GET_BONUS_CARD_MAILING_TEMPLATES_FAIL = "GET_BONUS_CARD_MAILING_TEMPLATES_FAIL";

export const CREATE_MAILING_FOR_BONUS_CARD_START = "CREATE_MAILING_FOR_BONUS_CARD_START";
export const CREATE_MAILING_FOR_BONUS_CARD_SUCCESS = "CREATE_MAILING_FOR_BONUS_CARD_SUCCESS";
export const CREATE_MAILING_FOR_BONUS_CARD_FAIL = "CREATE_MAILING_FOR_BONUS_CARD_FAIL";

export const UPDATE_MAILING_FOR_BONUS_CARD_START = "UPDATE_MAILING_FOR_BONUS_CARD_START";
export const UPDATE_MAILING_FOR_BONUS_CARD_SUCCESS = "UPDATE_MAILING_FOR_BONUS_CARD_SUCCESS";
export const UPDATE_MAILING_FOR_BONUS_CARD_FAIL = "UPDATE_MAILING_FOR_BONUS_CARD_FAIL";

export const DELETE_MAILING_FOR_BONUS_CARD_START = "DELETE_MAILING_FOR_BONUS_CARD_START";
export const DELETE_MAILING_FOR_BONUS_CARD_SUCCESS = "DELETE_MAILING_FOR_BONUS_CARD_SUCCESS";
export const DELETE_MAILING_FOR_BONUS_CARD_FAIL = "DELETE_MAILING_FOR_BONUS_CARD_FAIL";
